<template>
    <portal target="#modal-target">
        <div class="modal">
            <div ref="modalBox" v-click-away="handleEscape" :class="modalBodyClass">
                <button v-if="showCloseIcon" class="modal__close" type="button" @click="handleEscape">
                    <common-icon name="close-black" size="large"></common-icon>
                </button>
                <h4 v-if="heading" :class="headingClass">
                    {{ heading }}
                </h4>
                <slot></slot>
            </div>
        </div>
    </portal>
</template>

<script>
    export default {
        props: {
            heading: { type: String, default: null },
            headingCenter: { type: Boolean, default: false },
            width: { type: String, default: 'base' },
            height: { type: String, default: null },
            showCloseIcon: { type: Boolean, default: true },
            modalDimensions: { type: Object, default: undefined },
            padding: { type: String, default: undefined },
        },

        computed: {
            modalBodyClass() {
                return {
                    modal__body: true,
                    [`modal__body--width-${this.width}`]: this.width,
                    [`modal__body--height-${this.height}`]: this.height,
                    [`modal__body--padding-${this.padding}`]: this.padding,
                }
            },
            headingClass() {
                return {
                    modal__heading: true,
                    'modal__heading--center': this.headingCenter,
                }
            },
        },

        methods: {
            handleEscape(event) {
                event.stopPropagation()
                this.emitEvent({ name: 'close' })

                window.removeEventListener('popstate', this.closeOnBack)
                history.replaceState(null, document.title)
            },

            closeOnBack(event) {
                this.handleEscape(event)
            },
        },

        mounted() {
            const modalComponent = this.$refs.modalBox
            const modalElement = modalComponent

            this.emitEvent({ name: 'modal-dimensions', payload: modalElement.getBoundingClientRect() })
            document.body.style.overflow = 'hidden'

            history.pushState({ modalOpen: true }, document.title)
            window.addEventListener('popstate', this.closeOnBack)
        },

        beforeUnmount() {
            document.body.style.overflow = 'auto'

            window.removeEventListener('popstate', this.closeOnBack)
            history.replaceState(null, document.title)
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    @include breakpoint(smartphone-large) {
        .modal__heading {
            margin-top: 30px;
        }
    }
</style>
